import styled from 'styled-components';

import Button from '@williamhill/rosi-ui-shared/src/components/button';

export default styled(Button).attrs(({ modifiers }) => ({ modifiers: modifiers ?? 'primary' }))`
  border-radius: 3rem;
  padding: 1.2rem;
  font-size: 1.8rem;
  font-weight: 600;
  width: 100%;
`;
